import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const createDefaultQnsAction = createAsyncThunk(
    'create-default-question-answer',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/support-server/api/create-default-question-answer`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createDefaultQnsSlice = createSlice({
    name: 'create-default-question-answer',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createDefaultQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createDefaultQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createDefaultQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createDefaultQnsReducer = createDefaultQnsSlice.reducer